import { Component, OnInit } from '@angular/core';
import { HelperService } from "../../services/helper/helper.service";
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AddDidsComponent } from '../popups/add-dids/add-dids.component';
import { PaymentComponent } from '../payment/payment.component';
import { DidService } from '../../services/did/did.service';
import { UserService } from '../../services/user/user.service';
import { PeersService } from '../../services/peers/peers.service';
import { ConfirmDialogComponent } from '../popups/confirm-dialog/confirm-dialog.component';
import { EditDidsComponent } from '../popups/edit-dids/edit-dids.component';
import { LocalStorage } from '@ngx-pwa/local-storage';

@Component({
    selector: 'app-dids',
    templateUrl: './dids.component.html',
    styleUrls: ['./dids.component.scss']
})
export class DidsComponent implements OnInit {

    public loading;
    public searchFilter;
    public user : any = {};
    public dids = [];
    public selectedOrder = 'last';
    public filteredDids = [];

    public atualPage = 'numeros';

    public users = [];
    public peers = [];

    animal: string;
    name: string;

    constructor(
        private helperService: HelperService,
        private snackBar: MatSnackBar,
        private router: Router,
        public dialog: MatDialog,
        public didService: DidService,
        public userService: UserService,
        public peersService: PeersService,
        public localStorage: LocalStorage,
    ) { }

    ngOnInit() {
        this.init();
    }

    init() {
        this.loading = true;
        this.helperService.init().then((res) => {
            
            if (res) {
                this.user = res;
                if (this.user.payment) {
                    this.listDids(()=>{
                        this.listUsersCrm(()=>{
                            this.listPeers(()=>{
                                this.getLabels();
                                this._filter('');
                                this.loading = false;
                            });
                        });
                    });
                }else{
                    this.loading = false;
                }
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: "Assinatura Inválida"
                });
                this.router.navigate(['/notfound']);
            }
        })
    }

    listDids(callback = null){
        this.didService.list().subscribe((res)=>{
            this.dids = res.dids;
            // this.dids = [];

            if(callback) callback();
        })
    }

    listUsersCrm(callback = null){
        this.userService.listUsersCrm().subscribe((res)=>{
            this.users = res.data;

            if(callback) callback();
        })
    }

    listPeers(callback = null) {
        this.peersService.list().subscribe((res)=>{
            this.peers = res.peers;

            this.peers.forEach((peer)=>{
                this.users.forEach((user)=>{
                    if(peer.user_crm_id == user.id){
                        peer.user = user.nome;
                    }
                })
            })
            this.loading = false;
            if(callback) callback();
        })
    }

    getLabels(){
        this.dids.forEach((did)=>{
            if(did.redirect == 'peer') {
                this.peers.forEach((peer)=>{
                    if(did.redirect_id == peer.id){
                        did.redirect_label = 'Ramal - ' + peer.peer_number + ' - ' + peer.user;
                    }
                })
            }
        })
    }


    openDialogAdd(): void {
        const dialogRef = this.dialog.open(AddDidsComponent, {
            width: '400px',
            data: {
                peers: this.peers
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.init();
        });
    }

    
    openDialogEdit(id): void {
        const dialogRef = this.dialog.open(EditDidsComponent, {
            width: '400px',
            data: {
                peers: this.peers,
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.init();
        });
    }
    

    openDialogPayment(): void {
        const dialogRef = this.dialog.open(PaymentComponent, {
            width: '600px',
            data: { name: "nome teste", animal: "animal teste" }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            this.animal = result;
        });
    }

    openDialogDelete(id): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '600px',
            data: {
                msg: "Tem certeza que deseja deletar esse número?",
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result){
                if(result.confirm){
                    this.delete(result.id);
                }
            }
        });
    }

    delete(id){
        this.peers = [];
        this.dids = [];
        this.users = [];
        this.peers = [];
        this.loading = true;
        this.didService.delete(id).subscribe((res)=>{
            this.loading = false;
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg
            });
            this.init();
        })
    }


    _filter(value) {
        this.filteredDids = this.dids.filter((peer) => {
            var fields = Object.entries(peer);
            if (this.checkFilter(value, fields)) {
                return peer;
            }

        })
        this.orderBy();
    }

    checkFilter(value, fields) {
        var found = false;
        fields.forEach((field) => {
            if (field[1] != null) {
                if (field[1].toString().toLowerCase().includes(value.toLowerCase())) {
                    found = true;
                }

                if (field[1] == 0) {
                    if ("Sim".toLocaleLowerCase().includes(value.toLowerCase())) {
                        found = true;
                    }
                }

                if ((field[1] == 1) && (field[0] != 'active')) {
                    if ("Não".toLocaleLowerCase().includes(value.toLowerCase())) {
                        found = true;
                    }
                }
            }
        })
        return found;
    }

    orderBy() {

        var arrayTemp = JSON.parse(JSON.stringify(this.filteredDids));

        for (var i = 0; i < arrayTemp.length - 1; i++) {
            for (var j = i + 1; j < arrayTemp.length; j++) {
                if (this.selectedOrder == 'last') {
                    if (new Date(arrayTemp[j].created_at) > new Date(arrayTemp[i].id)) {
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                } else {
                    if (new Date(arrayTemp[j].id) < new Date(arrayTemp[i].id)) {
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                }
            }
        }
        this.filteredDids = JSON.parse(JSON.stringify(arrayTemp));
    }

    openChat() {
        this.localStorage.getItem('user').subscribe((item:any) => {
            octadesk.chat.login({ 
                name: item.name, 
                email: item.email 
            }); 
    
            octadesk.chat.showApp();
        })
    }

}
